import { Component, OnInit, Renderer, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {
  CommonUtility, WpPerson
} from '../shared';
import { DateUtility, ServerConstantsService, WpEtEnrollment } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { DataService } from '../shared';
import { NotificationsService } from 'angular2-notifications';
import { Observable } from 'rxjs/Observable';
import { CanComponentDeactivate, CanDeactivateGuardService } from '../shared/modals/modal-popup/can-deactivate-gaurd.service';
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';
import {GridOptions} from 'ag-grid/main';
import {  
  SINGLE_ROW_HEADER
} from '../shared';
import { ColDef } from 'ag-grid-community';
import { ComponentRecommendation } from '../shared/model/component-recommendation.model';

@Component({
  selector: 'app-component-details',
  templateUrl: './review-recommendations.component.html',
  styleUrls: ['./review-recommendations.component.scss']
})
export class ReviewRecommendationComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('headerText') headerText: ElementRef;
  @ViewChild('prevText') prevText: ElementRef;

  
  columnDefsIndv: ColDef[];
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;
  context: any;
  results: any = [];
  rowData: any[];    
  tabToNextCell: any;
  gridApi;
  gridApiIndv;
  gridOptions: GridOptions;
  firstTime: Boolean = true;
  components: ComponentRecommendation[] = [];
  wpPerson: WpPerson;
  name: string;
  sharedData: any;
  isChangeDetected: boolean;
  serverConstants: any;
  enrollment: WpEtEnrollment;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private rendere: Renderer,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtility: DateUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService
  ) {   
    this.gridOptions = <GridOptions>{};
    this.serverConstants = serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get('COMPS') === undefined) {
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    console.log('ngOnInit =====');
    this.sharedData = this.dataService.getSharedDataObject();
    //console.log('shared Data---'+ this.dataService.getSharedDataObject().get('ASMNT'));

    let personId;
    if (this.sharedData.get('wpPersonId') !== null && this.sharedData.get('wpPersonId') !== undefined) {
      personId = this.sharedData.get('wpPersonId');
    }
    console.log('personId =='+ personId);
    
    let enrollmentId;
    if (this.sharedData.get('etEnrollment') !== null && this.sharedData.get('etEnrollment') !== undefined) {
      console.log('etEnrollment ==' + this.sharedData.get('etEnrollment').id);   
      enrollmentId =  this.sharedData.get('etEnrollment').id; 
    } 


    let wpPerson;    
    if (this.sharedData.get('wpPerson') !== null && this.sharedData.get('wpPerson') !== undefined) {     
      wpPerson = this.sharedData.get('wpPerson');
      console.log('from sharedData wpPerson ==== ' + wpPerson.firstName + ' ' + wpPerson.lastName);
      this.name = wpPerson.firstName + ' ' + wpPerson.lastName;
    } else {
        //Retrieve Person Data
        this.wpPerson = new WpPerson();   
        this.http.post<WpPerson>(this.serverConstants.COMMON_SERVER_API_URL + '/persondata/load', parseInt(personId)).subscribe(
          (data: WpPerson) => {

            console.log('/persondata/load ============ ');
            // convert date to the proper format for UI
            this.wpPerson = data;           
            this.dataService.removeValueFromSharedDataMap("wpPerson");
            this.dataService.addValueToSharedDataMap("wpPerson", this.wpPerson);
            console.log('review recommendation person object ======= ' + this.wpPerson.firstName);
            this.dataService.removeValueFromSharedDataMap("personServiceCounty");
            this.dataService.addValueToSharedDataMap("personServiceCounty", this.wpPerson.serviceCounty);
            wpPerson = this.sharedData.get('wpPerson');
            console.log('wpPerson ==== ' + wpPerson.firstName + ' ' + wpPerson.lastName);
            this.name = wpPerson.firstName + ' ' + wpPerson.lastName;
          }, response => {            
          }, () => {
          });
    }

    
   
    
    this.getColumnDefinitions();

    if (personId !== null && enrollmentId !== null) {
      console.log(' personId - ' + personId + ' and etEnrollmentID - ' + enrollmentId)
      const request = new RequestLoad(personId, enrollmentId);
      //const request = new RequestLoad('776014', '113092');
      //const request = new RequestLoad('776014', '100146');      
      this.load(request);
    }
    
  }  

  load(request) {
    this.http.post<ComponentRecommendation[]>(this.serverConstants.SERVER_API_URL + '/component/recommendations', request).subscribe(
      (data) => {       
          if (data.length > 0) {
            this.components = data;            
          } else {
            this.components = [];           
          }
        
      }, response => {
       
      }, () => {

      });
  }

  onGridReadyIndv(params) {
    this.gridApiIndv = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  loadComponentDetails() {
    this.dataService.removeValueFromSharedDataMap('componentObject');
    this.router.navigate(['/task/componentSummary/componentDetails']);

  }

  setDisplayedRowAtIndex() {
    // get the first row
    const index = this.gridApi.getFirstDisplayedRow();
    const rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  onPaginationChanged() {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick(event) {
    this.firstTime = false;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if(this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }   
  };

  getColumnDefinitions() {    

    this.columnDefsIndv = [
      {
        headerName: 'Component',
        field: 'componentName',        
        width: 250,
        //cellStyle: {'text-align': 'center !important'},
      },
      {
        headerName: 'Score',
        field: 'score',        
        width: 150,
        autoHeight: true,
        //cellStyle: {'white-space': 'normal', 'text-align': 'center !important'},
        cellStyle: { 'white-space': 'normal' },
        suppressFilter: false,
      },
      {
        headerName: 'Rank',
        field: 'rank',       
        width: 150,
        autoHeight: true,
        //cellStyle: {'white-space': 'normal','text-align': 'center !important'},
        cellStyle: { 'white-space': 'normal' },
        suppressFilter: false,        
        //valueFormatter: this.agGridUtility.formatSsn,
        //cellRenderer: this.getSsnCell,
      },
      {
        headerName: 'Action',
        field: '',
        cellRenderer: this.getCreateLink,
        //cellRenderer: this.getEditButtonIndv,
        //cellStyle: {'text-align': 'center !important'},
        width: 170,
        suppressFilter: true,
        autoHeight: true,     
      }
    ];

    this.context = {
      component: this,
    };
    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };
  
  }

  getCreateLink(params) {
    const that = params.context.component;
    const element = document.createElement('a');
    element.innerHTML = 'Create';
    element.addEventListener('click', () => {
      console.log('Component Code = ' + params.data.componentCd);
      that.dataService.addValueToSharedDataMap('componentCd', params.data.componentCd);
      that.router.navigate(['/task/componentSummary/componentDetails']);
    });
    element.addEventListener('keydown', (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        that.dataService.addValueToSharedDataMap('componentCd', params.data.componentCd);
        that.router.navigate(['/task/componentSummary/componentDetails']);
      }
    });
    element.setAttribute('tabindex', '0');
    return element;
  }

}

class RequestLoad {
  constructor(
    public wpPersonId: String,
    public etEnrollmentId: String
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/review-recommendations/review-recommendations.component.ts